import script from "./AddressCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AddressCardComponent.vue?vue&type=style&index=0&id=86e0d4f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86e0d4f6"]])

export default __exports__